"use client";

import { type ReactNode } from "react";
import { motion } from "motion/react";

interface StepContainerProps {
	children: ReactNode;
}

const TRANSITION = { duration: 0.25, ease: "easeOut" } as const;

const STACK = "flex flex-col gap-3 w-full md:gap-4";

/** Static centred column; children placed here survive step changes. */
export const StepColumn = ({ children }: StepContainerProps) => (
	<div className={`${STACK} max-w-xl mx-auto py-2 md:py-4`}>{children}</div>
);

/** Fades its children in on mount. */
export const StepFadeIn = ({ children }: StepContainerProps) => (
	<motion.div
		initial={{ opacity: 0, y: 8 }}
		animate={{ opacity: 1, y: 0 }}
		transition={TRANSITION}
		className={STACK}
	>
		{children}
	</motion.div>
);

export const StepContainer = ({ children }: StepContainerProps) => (
	<StepColumn>
		<StepFadeIn>{children}</StepFadeIn>
	</StepColumn>
);
